import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
	Row,
	Col,
	Input,
	Button,
	notification,
	Form,
	Card,
	Switch,
	Result,
	Space,
} from 'antd';
import ReadMoreArea from '@foxeian/react-read-more';
import { useNavigate, useParams } from 'react-router-dom';
import {
	XButton,
	XCardsTransparent,
	XCardSummaryEdit,
	XSwitch,
	XTag,
	XTag2,
	XThemeContainer,
	XThemeSwitchBtn,
	XThemeTag,
	XThemeForm,
	XThemeInputText,
	XThemeFilterButton,
	XThemeGradientButton,
	XThemeFilterCircleButton,
} from '../../styles/GlobalThemeStyle';
import { ArrowLeftOutlined } from '@ant-design/icons';
import {
	XCardBackBg,
	XButtonBack,
	XEditTitle,
	XThemeCardCaseOperations,
	XThemeAvatarName,
	XThemMainTitle,
	XThemeAddressWrap,
} from '../CaseForm/CaseFormStyle';
import { XContainer } from '../../styles/GlobalThemeStyle';
import HeaderFile from '../../components/Header/HeaderFile';
import moment from 'moment';

// actions

import {
	getCaseByIdApi,
	getCaseByIdReset,
} from '../../actions/getCaseByIdAction';
import {
	getFeedbackByIdApi,
	getFeedbackByIdReset,
} from '../../actions/getFeedbackByIdAction';
import {
	editFeedbackApi,
	editFeedbackReset,
} from '../../actions/editFeedbackAction';

import {
	checkModulePermissions,
	toTitleCase,
	truncateString,
} from '../../utils/helper';
import { XPara1 } from '../AnalyseCoverage/AnalyseCoverageStyle';
import Header from '../../components/Header/Header';

const FeedbackView = (props) => {
	const {
		getFeedbackById,
		getFeedbackByIdReset,
		getFeedbackByIdState,
		editFeedbackReset,
		editFeedback,
		editFeedbackState,
	} = props;
	const navigate = useNavigate();
	const id = useParams().id;
	const [form] = XThemeForm.useForm();
	const [formData, setFormData] = useState({
		status: 'success',
		successful_claim_commission_criteria: 'percentage',
		successful_claim_commission_fixed_value: null,
		successful_claim_commission_percentage_value: null,
		rejected_claim_commission_criteria: 'percentage',
		rejected_claim_commission_fixed_value: null,
		rejected_claim_commission_percentage_value: null,
		case_amount: null,
		claim_amount: null,
		status_logs: [],
	});
	const [pageContent, setPageContent] = useState({
		original_medical_coverage: '',
		updated_medical_coverage: '',
		refined_medical_coverage: '',
		original_medical_coverage_applicable: '',
		updated_medical_coverage_applicable: 'Yes',
		refined_medical_coverage_applicable: 'Yes',
		status: '',
	});

	const handleSubmitFeedback = () => {
		editFeedback({ ...pageContent, status: 'analysed' });
	};
	// use effects
	useEffect(() => {
		if (id) getFeedbackById({ id: id });
	}, [id]);

	useEffect(() => {
		if (getFeedbackByIdState.apiState === 'success') {
			setFormData({
				...getFeedbackByIdState.data,
				id: getFeedbackByIdState.data.case_id?._id,
				allocated_to: getFeedbackByIdState.data.case_id?.allocated_to
					?.name
					? getFeedbackByIdState.data.case_id?.allocated_to.name
					: '-',
				status: getFeedbackByIdState.data.status,
			});

			setPageContent({
				...getFeedbackByIdState.data,
				id: getFeedbackByIdState.data._id,
				updated_medical_coverage_applicable:
					getFeedbackByIdState.data
						.updated_medical_coverage_applicable,
				refined_medical_coverage_applicable:
					getFeedbackByIdState.data
						.refined_medical_coverage_applicable ??
					getFeedbackByIdState.data
						.updated_medical_coverage_applicable,
			});

			form.setFieldsValue({
				...getFeedbackByIdState.data,
			});
			getFeedbackByIdReset();
		}
	}, [getFeedbackByIdState]);

	useEffect(() => {
		if (editFeedbackState.apiState === 'success') {
			notification.success({ message: editFeedbackState.message });
			editFeedbackReset();
			navigate(-1);
		}
	}, [editFeedbackState]);

	return (
		<>
			{props.displayHeader ? (
				<></>
			) : (
				<>
					<Col lg={24} xl={24} xs={0} md={0}>
						<Header headerTag="Feedback Analysis" />
					</Col>
					<Col lg={0} xl={0} xs={24} md={24}>
						<HeaderFile activeNav="feedbackAnalysis" />
					</Col>
				</>
			)}
			<XThemeContainer fluid className="mt-3">
				{checkModulePermissions(
					'feedback-analysis',
				).sub_modules.includes('view-feedbacks') ? (
					<>
						{/* <XCardBackBg className="mb-3">
							<Row>
								<Col xs={24}>
									<XButtonBack
										onClick={() => navigate(-1)}
										icon={<ArrowLeftOutlined />}
										size="large"
									/>

									<XEditTitle>View Case</XEditTitle>
								</Col>
							</Row>
						</XCardBackBg> */}

						<XThemeCardCaseOperations className="largePadding mb-3">
							{formData.case_id ? (
								<Row gutter={(15, 15)} className="mb-3">
									<Col xs={12} className="mb-2 mb-md-0">
										<Space>
											<XThemeAvatarName gap="4">
												{formData.case_id
													.patient_first_name &&
													formData?.case_id
														.patient_first_name[0]}
												{formData.case_id
													.patient_last_name &&
													formData?.case_id
														.patient_last_name[0]}
											</XThemeAvatarName>
											<XThemMainTitle>
												{
													formData.case_id
														.patient_first_name
												}{' '}
												{
													formData.case_id
														.patient_last_name
												}
												<br />
												<span>
													{formData.case_id.mrn}
												</span>
											</XThemMainTitle>
										</Space>
									</Col>
									<Col xs={12} className="text-end">
										<Space>
											<XPara1>
												Treatment Date :&nbsp;
												<span
													style={{ fontWeight: 600 }}
												>
													{moment(
														formData.treatment_date,
													).format('MMMM Do, YYYY')}
												</span>
											</XPara1>
											<XThemeTag
												className={formData.status}
											>
												{formData.status
													? truncateString(
															formData.status,
													  )
													: ''}
											</XThemeTag>
										</Space>
									</Col>
								</Row>
							) : (
								<Row>
									<Col xs={12} className="mb-2 mb-md-0">
										<XPara1 className="p-0">
											Feedback Date :&nbsp;
											<span style={{ fontWeight: 600 }}>
												{moment(
													formData.createdAt,
												).format('MMMM Do, YYYY')}
											</span>
										</XPara1>
									</Col>
									<Col
										xs={24}
										sm={24}
										md={12}
										lg={12}
										className="text-start text-md-end"
									>
										<XThemeTag className={formData.status}>
											{formData.status
												? truncateString(
														formData.status,
												  )
												: ''}
										</XThemeTag>
									</Col>
								</Row>
							)}

							{formData.case_id && (
								<XThemeAddressWrap className="mb-3">
									<Row gutter={[15, 0]}>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Gender <br />
												<span>
													{formData.case_id.gender
														? toTitleCase(
																formData.case_id
																	.gender,
														  )
														: ''}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Date Of Birth <br />
												<span>
													{moment(
														formData.case_id
															.date_of_birth,
													).format('MMMM Do, YYYY')}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Age
												<br />
												<span>
													{moment().diff(
														moment(
															formData.case_id
																.date_of_birth,
														),
														'years',
													)}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Allocated To <br />
												<span>
													{formData.allocated_to
														? formData.allocated_to
														: ''}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Created On
												<br />
												<span>
													{moment(
														formData.createdAt,
													).format('MMMM Do, YYYY')}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Last Date
												<br />
												<span>
													{moment(
														formData.updatedAt,
													).format('MMMM Do, YYYY')}
												</span>
											</div>
										</Col>
									</Row>
								</XThemeAddressWrap>
							)}
						</XThemeCardCaseOperations>

						<XThemeCardCaseOperations className="largePadding mb-3">
							<Row gutter={[15, 0]}>
								<Col xs={24}>
									<div className="labelHeading">
										Clinical Summary
									</div>
								</Col>
								<Col xs={24} className="text-lg-end">
									<Form.Item className="labelStyle">
										<XThemeAddressWrap className="mt-3">
											<XPara1
												className="p-0 d-block"
												style={{
													textAlign: 'justify',
												}}
											>
												<ReadMoreArea
													expandLabel="Read More"
													collapseLabel="Read Less"
													className="readMore"
												>
													{formData.original_query}
												</ReadMoreArea>
											</XPara1>
										</XThemeAddressWrap>
									</Form.Item>
								</Col>
							</Row>
						</XThemeCardCaseOperations>

						<XThemeCardCaseOperations className="largePadding mb-3">
							<XThemeForm
								className="w-100"
								onFinish={handleSubmitFeedback}
								form={form}
								initialValues={pageContent}
							>
								<Row gutter={[15, 15]}>
									<Col
										xs={24}
										lg={
											formData.status === 'approved'
												? 24
												: 12
										}
										md={
											formData.status === 'approved'
												? 24
												: 12
										}
										xl={
											formData.status === 'approved'
												? 24
												: 12
										}
										className="mb-3 mb-md-0"
									>
										<Card
											title={
												<span
													style={{
														display: 'flex',
														justifyContent:
															'space-between',
														flexDirection: 'row',
														alignItems: 'center',
													}}
												>
													<span className="feedbackCardHeader">
														System Generated
													</span>
													<XTag2
														className={
															pageContent.original_medical_coverage_applicable
														}
													>
														{pageContent.original_medical_coverage_applicable ===
														'Yes'
															? toTitleCase(
																	'Covered',
															  )
															: toTitleCase(
																	'Not Covered',
															  )}
													</XTag2>
												</span>
											}
											style={{
												borderRadius:
													'20px 20px 20px 20px',
												height: '100%',
											}}
											headStyle={{
												background:
													pageContent.original_medical_coverage_applicable ===
													'Yes'
														? '#E1FCEF'
														: '#ff36361a',
												borderRadius:
													'20px 20px 0px 0px',
											}}
											prefix=""
										>
											<span className="subLabelStyle feedbackText">
												{
													pageContent.original_medical_coverage
												}
											</span>
										</Card>
									</Col>
									{formData.status === 'approved' ? (
										<></>
									) : (
										<>
											<Col
												xs={24}
												lg={12}
												md={12}
												xl={12}
											>
												<Card
													title={
														<span
															style={{
																display: 'flex',
																justifyContent:
																	'space-between',
																flexDirection:
																	'row',
																alignItems:
																	'center',
															}}
														>
															<span className="feedbackCardHeader">
																User Feedback
															</span>
															<XTag2
																className={
																	pageContent.updated_medical_coverage_applicable
																}
															>
																{!pageContent.feedback
																	? 'No Feedback'
																	: pageContent.updated_medical_coverage_applicable ===
																	  'Yes'
																	? toTitleCase(
																			'Covered',
																	  )
																	: toTitleCase(
																			'Not Covered',
																	  )}
															</XTag2>
														</span>
													}
													style={{
														borderRadius:
															'20px 20px 20px 20px',
														height: '100%',
													}}
													headStyle={{
														background:
															pageContent.updated_medical_coverage_applicable ===
															'Yes'
																? '#E1FCEF'
																: '#ff36361a',
														borderRadius:
															'20px 20px 0px 0px',
													}}
													className={
														pageContent.updated_medical_coverage_applicable
													}
												>
													<span className="subLabelStyle feedbackText">
														{
															pageContent.updated_medical_coverage
														}
													</span>
												</Card>
											</Col>

											<Col xs={24} className="mt-4">
												<XThemeForm.Item
													label="Modify Coverage"
													name="refined_medical_coverage_applicable"
													rules={[
														{
															required: true,
															message:
																'Please input Coverage',
														},
													]}
												>
													<XThemeSwitchBtn
														checkedChildren={'Yes'}
														unCheckedChildren={'No'}
														name="refined_medical_coverage_applicable"
														checked={
															pageContent.refined_medical_coverage_applicable ===
															'Yes'
																? true
																: false
														}
														onChange={(e) => {
															const value = e
																? 'Yes'
																: 'No';
															setPageContent({
																...pageContent,
																refined_medical_coverage_applicable:
																	value,
															});
														}}
													/>
												</XThemeForm.Item>
											</Col>
											<Col xs={24}>
												<XThemeForm.Item
													className="textAreaStyleDarkBorder drawerlabel"
													name="refined_medical_coverage"
													rules={[
														{
															required: true,
															message:
																'Please input Intro',
														},
													]}
												>
													<XThemeInputText.TextArea
														rows={5}
														size="large"
														placeholder="Modify the feedback"
														showCount
														onChange={(e) => {
															setPageContent({
																...pageContent,
																refined_medical_coverage:
																	e.target
																		.value,
															});
														}}
													/>
												</XThemeForm.Item>
											</Col>
											<Col
												xs={24}
												sm={{ span: 8, offset: 16 }}
												md={{ span: 6, offset: 18 }}
												lg={{ span: 6, offset: 18 }}
												xl={{ span: 4, offset: 20 }}
												className="mt-4 text-end"
											>
												<XThemeFilterButton
													className="backgroundRevers"
													htmlType="submit"
												>
													Modify Feedback
												</XThemeFilterButton>
											</Col>
										</>
									)}
								</Row>
							</XThemeForm>
						</XThemeCardCaseOperations>
					</>
				) : (
					<Result
						status="403"
						title="403"
						subTitle="Sorry, you are not authorized to access this page."
						extra={
							<Button
								type="primary"
								onClick={() => navigate('/')}
							>
								Back Home
							</Button>
						}
					/>
				)}
			</XThemeContainer>
		</>
	);
};

const mapStateToProps = (state) => ({
	getCaseByIdState: state.getCaseById,
	getFeedbackByIdState: state.getFeedbackById,
	editFeedbackState: state.editFeedback,
});

const mapDispatchToProps = (dispatch) => ({
	getCaseById: (data) => dispatch(getCaseByIdApi(data)),
	getCaseByIdReset: () => dispatch(getCaseByIdReset()),
	getFeedbackById: (data) => dispatch(getFeedbackByIdApi(data)),
	getFeedbackByIdReset: () => dispatch(getFeedbackByIdReset()),
	editFeedback: (data) => dispatch(editFeedbackApi(data)),
	editFeedbackReset: () => dispatch(editFeedbackReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackView);
